import React from "react";
import { usePermission } from "../../../context/permissionsContext";
import {
  HeadingStyled,
  NotAuthorized,
  SubscriptionExpired,
} from "../../styled/Elements";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../context/userContext";
import { useLocation } from "react-router-dom";

const PermissionWrapper = ({
  children,
  isPermitted,
  moduleId,
  actionId,
  featureId,
  unauthorizedComponent,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { checkPermission } = usePermission();
  const { user } = useUser();

  if (isPermitted && !checkPermission(moduleId, actionId, featureId)) {
    return unauthorizedComponent || <NotAuthorized />;
  }
  if (
    user?.current_organization?.plan_detail?.expired &&
    !user?.current_organization?.plan_detail?.is_grace_period_active &&
    !location.pathname.includes("settings/billing")
  ) {
    return <SubscriptionExpired />;
  }

  return <>{children}</>;
};

export default PermissionWrapper;
